/* eslint-env browser */
import React from "react";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import { translate } from "react-i18next";
import config from "config/config.js";

export class BaseFooterDownloadApp extends React.Component {
  static get NAME() {
    return "BaseFooterDownloadApp";
  }
  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    /* FACEBOOK PIXEL */
    ReactPixel.init("1681882595188442");
    // ReactPixel.pageView(); // For tracking page view
  }

  render() {
    const t = this.props.t;
    return (
      <div style={{ marginTop: "30px" }}>
        <div>
          <a
            href="https://play.google.com/store/apps/details?id=com.foodiestrip"
            title={t("homeContent.squeeze_page_alt_image_android")}
            target="blank"
            onClick={() => {
              ReactPixel.trackCustom("goToStore", { store: "google play" });
            }}
            rel="nofollow"
          >
            <img
              src={`${
                config.imageRoot
              }background_images/homepage_02/download_app_android.png`}
              alt={t("userProfile.downloadTheApp")}
              title={t("homeContent.squeeze_page_alt_image_android")}
              style={{ width: "100px" }}
            />
          </a>
          <a
            href="https://itunes.apple.com/it/app/foodiestrip-real-reviews/id1288164525?mt=8"
            title={t("homeContent.squeeze_page_alt_image_ios")}
            target="blank"
            onClick={() => {
              ReactPixel.trackCustom("goToStore", { store: "apple store" });
            }}
            className="footer-download-app-second-image"
            rel="nofollow"
          >
            <img
              src={`${
                config.imageRoot
              }background_images/homepage_02/download_app_apple.png`}
              alt={t("userProfile.downloadTheApp")}
              title={t("homeContent.squeeze_page_alt_image_ios")}
              style={{ width: "100px" }}
            />
          </a>
        </div>
      </div>
    );
  }
}

BaseFooterDownloadApp.propTypes = {
  language: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired
};

const FooterDownloadApp = translate()(BaseFooterDownloadApp);
export default FooterDownloadApp;



// WEBPACK FOOTER //
// ./src/components/Footer/FooterDownloadApp.jsx